var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMatch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 96,
    viewBox: "0 0 240 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1849_29902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.24 8L202.88 17.92C199.48 16.68 195.84 16 192 16C188.2 16 184.52 16.68 181.16 17.88L182.8 8H201.24ZM202.88 78.08L201.24 88H182.8L181.16 78.12C184.52 79.32 188.2 80 192 80C195.84 80 199.48 79.32 202.88 78.08ZM208 0H176L172.2 22.92C164.76 28.76 160 37.8 160 48C160 58.2 164.76 67.24 172.2 73.08L176 96H208L211.84 73.08C219.24 67.24 224 58.16 224 48C224 37.84 219.24 28.76 211.84 22.92L208 0ZM192 72C178.76 72 168 61.24 168 48C168 34.76 178.76 24 192 24C205.24 24 216 34.76 216 48C216 61.24 205.24 72 192 72Z",
    fill: "#EBDFC8"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1849_29902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.24 8L58.88 17.92C55.48 16.68 51.84 16 48 16C44.2 16 40.52 16.68 37.16 17.88L38.8 8H57.24ZM58.88 78.08L57.24 88H38.8L37.16 78.12C40.52 79.32 44.2 80 48 80C51.84 80 55.48 79.32 58.88 78.08ZM64 0H32L28.2 22.92C20.76 28.76 16 37.8 16 48C16 58.2 20.76 67.24 28.2 73.08L32 96H64L67.84 73.08C75.24 67.24 80 58.16 80 48C80 37.84 75.24 28.76 67.84 22.92L64 0ZM48 72C34.76 72 24 61.24 24 48C24 34.76 34.76 24 48 24C61.24 24 72 34.76 72 48C72 61.24 61.24 72 48 72Z",
    fill: "#EBDFC8"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1849_29902)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.04 56H80V64H108.04V76L124 60L108.04 44V56ZM131.96 52V40H160V32H131.96V20L116 36L131.96 52Z",
    fill: "#EBDFC8"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1849_29902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(144)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1849_29902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1849_29902"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(72)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatch);
export default __webpack_public_path__ + "static/media/match.fd7f290191cdea3719c67ebd4477bfbb.svg";
export { ForwardRef as ReactComponent };